
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gain/stable-vault",
      function () {
        return require("private-next-pages/gain/stable-vault.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gain/stable-vault"])
      });
    }
  